var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faPen, faRedoAlt, } from "@fortawesome/pro-solid-svg-icons";
import toast from "react-hot-toast";
import { useGetModuleStudioLabelsQuery, useGetModuleStudioSubpanelQuery, useLoadSystemConfigurationsQuery, useSaveModuleStudioSubpanelMutation, useSaveStudioLabelsMutation, } from "@/store/api";
import { useTranslation } from "react-i18next";
import { LoaderImage } from "@/utils/loader";
var Field = function (_a) {
    var item = _a.item, index = _a.index, type = _a.type, moduleStrings = _a.moduleStrings, updateItemDefault = _a.updateItemDefault, onChangeEdit = _a.onChangeEdit;
    var moduleName = useParams().moduleName;
    var t = useTranslation(["common", moduleName ? moduleName : ""]).t;
    var _b = useState(null), openInputIndex = _b[0], setOpenInputIndex = _b[1];
    var handleClickOutside = function (event) {
        if (openInputIndex !== null && !event.target.closest(".editable-input")) {
            setOpenInputIndex(null);
        }
    };
    useEffect(function () {
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openInputIndex]);
    return (_jsx(Draggable, __assign({ draggableId: "".concat(type, "-").concat(item.name, "-").concat(index), index: index }, { children: function (provided) { return (_jsx("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { className: "panel__body--list bg-white border border-gray-200 p-1 mb-2 flex justify-between items-center cursor-move text-sm" }, { children: _jsxs("div", __assign({ className: "grid grid-cols-2 gap-2 w-full p-0.5 text-gray-700" }, { children: [_jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("label", { children: item.vname
                                    ? t(item.vname, { ns: moduleName || "common" })
                                    : item.name }), _jsxs("label", { children: ["[", item.name, "] "] })] })), _jsx("div", __assign({ className: " " }, { children: _jsxs("div", __assign({ className: "flex flex-col justify-end  items-end" }, { children: [_jsx(FontAwesomeIcon, { icon: faPen, className: " cursor-pointer ", onClick: function () { return setOpenInputIndex(index); } }), _jsx("div", __assign({ className: "" }, { children: _jsx("label", __assign({ className: "font-medium" }, { children: openInputIndex === index ? (_jsx("input", { readOnly: type === "hidden" ? true : false, autoFocus: type === "hidden" ? false : true, value: item.width, onChange: updateItemDefault, type: "text", className: "  border border-gray-300 rounded-sm px-2 text-sm   ".concat(type === "hidden"
                                                ? " cursor-not-allowed"
                                                : "focus:border-blue-300 focus:outline-none focus:ring", " ") })) : item.width ? (item.width) : ("%") })) }))] })) }))] })) }))); } })));
};
export default function SubpanelEditor() {
    var _this = this;
    var _a;
    var _b = useParams(), packagesName = _b.packagesName, moduleName = _b.moduleName, type = _b.type, menu = _b.menu, dropdownName = _b.dropdownName, fieldName = _b.fieldName;
    var t = useTranslation(["common", "Studio", "ModuleBuilder"]).t;
    var _c = useState([]), defaultFields = _c[0], setDefaultFields = _c[1];
    var _d = useState([]), hiddenFields = _d[0], setHiddenFields = _d[1];
    var location = useLocation();
    var label = (location.state || {}).label;
    var _e = useState(label), subpanelName = _e[0], setSubpanelName = _e[1];
    var _f = useState({}), mod_strings = _f[0], setMod_strings = _f[1];
    var _g = useLoadSystemConfigurationsQuery(null), systemData = _g.data, error = _g.error;
    var systemConfig = (systemData === null || systemData === void 0 ? void 0 : systemData.data) || {};
    var defaultLanguage = ((_a = systemConfig.languages) === null || _a === void 0 ? void 0 : _a.default) || "fr_FR" || "";
    var labels_datas = useGetModuleStudioLabelsQuery({
        moduleName: moduleName,
        label: "all",
        lang: defaultLanguage,
    }).data;
    useEffect(function () {
        var _a;
        setMod_strings((_a = labels_datas === null || labels_datas === void 0 ? void 0 : labels_datas.data) === null || _a === void 0 ? void 0 : _a.MOD);
    }, [labels_datas]);
    var uppercaseFieldName = fieldName === null || fieldName === void 0 ? void 0 : fieldName.toUpperCase();
    var filteredModStrings = mod_strings &&
        Object.fromEntries(Object.entries(mod_strings).filter(function (_a) {
            var key = _a[0], value = _a[1];
            return key.includes(uppercaseFieldName) && value.includes(label);
        }));
    var _h = useGetModuleStudioSubpanelQuery({
        moduleName: moduleName,
        params: {
            subpanel_name: fieldName,
            lang: defaultLanguage,
        },
    }), list_subpanel = _h.data, refetch = _h.refetch;
    var _j = useSaveModuleStudioSubpanelMutation(), saveModuleStudioSubpanel = _j[0], _k = _j[1], saveSubpanel = _k.data, isloadingSaveSubpanel = _k.isLoading;
    var _l = useSaveStudioLabelsMutation(), saveStudioLabelMutation = _l[0], _m = _l[1], saveLabel = _m.data, isloadingSaveLabel = _m.isLoading;
    var getDefaultFields = function () { return __awaiter(_this, void 0, void 0, function () {
        var default_fields_1, hidden_fields, add_name_defaultFields;
        var _a;
        return __generator(this, function (_b) {
            if ((_a = list_subpanel === null || list_subpanel === void 0 ? void 0 : list_subpanel.data) === null || _a === void 0 ? void 0 : _a.viewdefs) {
                default_fields_1 = list_subpanel.data.viewdefs;
                hidden_fields = list_subpanel.data.list_fields;
                add_name_defaultFields = Object.keys(default_fields_1).reduce(function (acc, key) {
                    if (default_fields_1[key].usage !== "query_only") {
                        acc[key] = __assign(__assign({}, default_fields_1[key]), { name: default_fields_1[key].name || key });
                    }
                    return acc;
                }, {});
                setDefaultFields(add_name_defaultFields);
            }
            return [2 /*return*/];
        });
    }); };
    var getHiddenFields = function () {
        var _a;
        if ((_a = list_subpanel === null || list_subpanel === void 0 ? void 0 : list_subpanel.data) === null || _a === void 0 ? void 0 : _a.list_fields) {
            var listFields_1 = list_subpanel.data.list_fields;
            var default_fields_2 = list_subpanel.data.viewdefs;
            var hidden_fields_list = default_fields_2 &&
                Object.keys(listFields_1)
                    .filter(function (key) {
                    return !default_fields_2.hasOwnProperty(key) &&
                        !listFields_1[key].hasOwnProperty("usage") &&
                        !listFields_1[key].hasOwnProperty("width");
                })
                    .reduce(function (acc, key) {
                    acc[key] = listFields_1[key];
                    return acc;
                }, {});
            setHiddenFields(hidden_fields_list);
        }
    };
    var saveLayout = function (publish) {
        if (publish === void 0) { publish = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var substring_1, translationKey_subpanelName, matched_translate, labels, newLabels, resultLabels, new_list_fields, response, error_1;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        if (!(subpanelName !== label)) return [3 /*break*/, 2];
                        substring_1 = "_SUBPANEL_TITLE";
                        translationKey_subpanelName = Object.keys(filteredModStrings);
                        matched_translate = translationKey_subpanelName.find(function (item) { return item.includes(substring_1); });
                        labels = {};
                        if (matched_translate) {
                            labels = (_a = {},
                                _a[matched_translate] = subpanelName,
                                _a);
                        }
                        else {
                            labels = (_b = {},
                                _b[translationKey_subpanelName] = subpanelName,
                                _b);
                        }
                        newLabels = Object.entries(labels).map(function (_a) {
                            var key = _a[0], value = _a[1];
                            return [
                                "label_" + key,
                                value,
                            ];
                        });
                        return [4 /*yield*/, saveStudioLabelMutation({
                                moduleName: moduleName,
                                body: {
                                    package: packagesName,
                                    lang: defaultLanguage,
                                    new_labels: newLabels,
                                },
                            }).unwrap()];
                    case 1:
                        resultLabels = _c.sent();
                        _c.label = 2;
                    case 2:
                        if (!Array.isArray(defaultFields)) return [3 /*break*/, 4];
                        new_list_fields = defaultFields.reduce(function (acc, item) {
                            if (item.name) {
                                var widthWithPercentage = item.width && !item.width.includes("%")
                                    ? "".concat(item.width, "%")
                                    : item.width;
                                acc[item.name] = __assign(__assign({}, item), { width: widthWithPercentage });
                            }
                            return acc;
                        }, {});
                        return [4 /*yield*/, saveModuleStudioSubpanel({
                                moduleName: moduleName,
                                params: {
                                    subpanel_name: fieldName,
                                },
                                body: {
                                    new_list_fields: new_list_fields,
                                },
                            }).unwrap()];
                    case 3:
                        response = _c.sent();
                        console.log("Subpanel saved:", response);
                        _c.label = 4;
                    case 4:
                        // End of saving subpanel title
                        if (Array.isArray(defaultFields) || subpanelName !== label) {
                            toast.success("Save and publish Layout Subpanel");
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _c.sent();
                        console.error("Error saving layout:", error_1);
                        toast.error("Layout not saved");
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    var saveAndPublishLayout = function () {
        saveLayout(true);
    };
    var handleDragEnd = function (result) {
        if (!result.destination)
            return;
        var sourceList = result.source.droppableId === "default-fields"
            ? defaultFields
            : hiddenFields;
        var destList = result.destination.droppableId === "default-fields"
            ? defaultFields
            : hiddenFields;
        var sourceClone = Array.from(Object.values(sourceList));
        var destClone = Array.from(Object.values(destList));
        var movedItem = sourceClone.splice(result.source.index, 1)[0];
        if (result.source.droppableId === result.destination.droppableId) {
            //within the same list
            sourceClone.splice(result.destination.index, 0, movedItem);
            if (result.source.droppableId === "default-fields") {
                setDefaultFields(sourceClone);
            }
            else {
                setHiddenFields(sourceClone);
            }
        }
        else {
            //from one list to another
            destClone.splice(result.destination.index, 0, movedItem);
            if (result.source.droppableId === "default-fields") {
                setDefaultFields(sourceClone);
                setHiddenFields(destClone);
            }
            else {
                setDefaultFields(destClone);
                setHiddenFields(sourceClone);
            }
        }
    };
    var updateItemDefault = function (name, newDefaultValue) {
        var updatedFields = defaultFields &&
            Object.values(defaultFields).map(function (item) {
                return item.name === name ? __assign(__assign({}, item), { width: newDefaultValue }) : item;
            });
        setDefaultFields(updatedFields);
    };
    useEffect(function () {
        refetch();
        getDefaultFields();
        getHiddenFields();
    }, [list_subpanel]);
    var _o = useState(false), renderDroppable = _o[0], setRenderDroppable = _o[1];
    var renderDroppableAfterAnimationFrame = function () {
        if (!renderDroppable) {
            requestAnimationFrame(function () {
                setRenderDroppable(true);
            });
        }
    };
    var restoreDefault = function () {
        getDefaultFields();
        getHiddenFields();
    };
    return (_jsx("div", __assign({ className: "flex columns max-h-[50vh] overflow-auto" }, { children: _jsx("div", __assign({ className: "w-full px-5" }, { children: _jsxs("div", __assign({ className: "" }, { children: [_jsxs("div", __assign({ className: "level head-form-page mb-3" }, { children: [_jsxs("div", __assign({ className: "flex flex-row " }, { children: [_jsx("div", __assign({ className: "level-item" }, { children: _jsxs("button", __assign({ className: "border rounded-md p-2 hover:border-gray-400", onClick: saveAndPublishLayout }, { children: [t("LBL_BTN_SAVEPUBLISH", { ns: "Studio" }), " \u00A0", _jsx(FontAwesomeIcon, { icon: faCheckCircle })] })) })), _jsx("div", __assign({ className: "ml-2" }, { children: _jsxs("button", __assign({ className: "border rounded-md p-2 hover:border-gray-400", onClick: restoreDefault }, { children: [t("LBL_RESTORE_DEFAULT", { ns: "Studio" }), " \u00A0", _jsx(FontAwesomeIcon, { icon: faRedoAlt })] })) }))] })), _jsxs("div", __assign({ className: "flex flex-row my-6 items-center relative" }, { children: [_jsx("label", { children: t("app.LBL_TITLE_TEXT", { ns: "common" }) }), _jsx("input", { className: "border p-1 mx-1 w-1/3 ", value: subpanelName, onChange: function (e) { return setSubpanelName(e.target.value); } }), isloadingSaveLabel && _jsx(LoaderImage, {})] }))] })), _jsx("section", { children: _jsx(DragDropContext, __assign({ onDragEnd: handleDragEnd }, { children: _jsxs("div", __assign({ className: "grid grid-cols-2 gap-4 w-full" }, { children: [_jsxs("div", __assign({ className: "column relative" }, { children: [_jsx("h2", __assign({ className: "text-xl font-medium mb-2" }, { children: t("LBL_DEFAULT", { ns: "ModuleBuilder" }).toUpperCase() })), _jsx("div", __assign({ className: "".concat(Object.values(defaultFields).length === 0 &&
                                                    "border h-96 rounded-md"), role: "list" }, { children: renderDroppable && defaultFields && (_jsx(Droppable, __assign({ droppableId: "default-fields" }, { children: function (provided, snapshot) { return (_jsxs("div", __assign({ ref: provided.innerRef }, provided.droppableProps, { children: [Object.values(defaultFields).map(function (item, index) { return (_jsx(Field, { index: index, item: item, type: "default", updateItemDefault: function (e) {
                                                                    return updateItemDefault(item.name, e.target.value);
                                                                } }, "default-".concat(item.name, "-").concat(index))); }), provided.placeholder, Object.values(defaultFields).length === 0 && (_jsx("div", __assign({ className: "flex flex-col mb-1 p-1 border-t cursor-move justify-between items-center" }, { children: _jsxs("span", __assign({ className: " text-gray-300" }, { children: [t("app.LBL_DROP_ITEMS_HERE", {
                                                                            ns: "common",
                                                                        }), " ", "..."] })) })))] }))); } }))) })), isloadingSaveSubpanel && _jsx(LoaderImage, {}), renderDroppableAfterAnimationFrame()] })), _jsxs("div", __assign({ className: "column" }, { children: [_jsx("h2", __assign({ className: "text-xl font-medium mb-2" }, { children: t("LBL_HIDDEN", { ns: "ModuleBuilder" }) })), _jsx("div", __assign({ className: "".concat(Object.values(hiddenFields).length === 0 &&
                                                    "border h-96 rounded-md"), role: "list" }, { children: _jsxs("div", __assign({ className: "" }, { children: [renderDroppable && hiddenFields && (_jsx(Droppable, __assign({ droppableId: "hidden-fields" }, { children: function (provided, snapshot) { return (_jsxs("div", __assign({ ref: provided.innerRef }, provided.droppableProps, { children: [Object.values(hiddenFields).map(function (item, index) { return (_jsx(Field, { index: index, item: item, type: "hidden" }, "hidden-".concat(item.name, "-").concat(index))); }), provided.placeholder, Object.values(hiddenFields).length === 0 && (_jsx("div", __assign({ className: "flex flex-col mb-1 p-1 border-t cursor-move justify-between items-center" }, { children: _jsxs("span", __assign({ className: " text-gray-300" }, { children: [t("app.LBL_DROP_ITEMS_HERE", {
                                                                                    ns: "common",
                                                                                }), " ", "..."] })) })))] }))); } }))), renderDroppableAfterAnimationFrame()] })) }))] }))] })) })) })] })) })) })));
}
